module.exports = __webpack_public_path__ + "img/20.d68f95ef.jpg";